export default {
  GET_USER_CLIENTS_REQUEST: '@@user-clients/GET_USER_CLIENTS_REQUEST',
  GET_USER_CLIENTS_SUCCESS: '@@user-clients/GET_USER_CLIENTS_SUCCESS',
  GET_USER_CLIENTS_ERROR: '@@user-clients/GET_USER_CLIENTS_ERROR',
  SET_USER_CLIENTS: '@@user-clients/SET_USER_CLIENTS',
  SET_CURRENT_ORGANIZATION: '@@user-clients/SET_CURRENT_ORGANIZATION',
};
